import { FC, memo } from "react";

import { ValidCardFlag } from "@/apis/clients";

interface Props {
  isUse?: ValidCardFlag;
}

const CreditStatusLabelBase: FC<Props> = ({ isUse }) => {
  return isUse ? (
    <div className="flex justify-center p-[2px] w-[100px] text-[#07917B] bg-[#DAF2EE] rounded-full">
      <div>利用可能</div>
    </div>
  ) : (
    <div className="flex justify-center p-[2px] w-[103px] text-theme bg-[#D3D3D3] rounded-full">
      <div>申請中</div>
    </div>
  );
};

export const CreditStatusLabel = memo(CreditStatusLabelBase);
